import api from "../../../services/api";

const getfasilitas = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/fasilitas").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTFASILITAS", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getfasilitasByid = ({ state, commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/fasilitas/" + state.id_user).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTFASILITASID", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getAllFasilitas = () => {
  return new Promise((resolve, reject) => {
    api.get("/asset").then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertFasilitas = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/update/fasilitas", state.tempFasilitas).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const getMasterFasilitasByid = ({ state, commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/fasilitas/by/" + state.id_user).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTFASILITASID", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertMasterFasilitas = ({ state }) => {
  return new Promise((resolve, reject) => {
    if (state.tempMasterFasilitas.id) {
      api
        .put("/master/fasilitas/" + state.tempMasterFasilitas.id, {
          ...state.tempMasterFasilitas,
          id: undefined
        })
        .then(
          response => {
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
    } else {
      api.post("/master/fasilitas", state.tempMasterFasilitas).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    }
  });
};

const deleteMasterFacility = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/faslitas/" + state.idMasterFacility).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const deleteUserFasilitas = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/fasilitas/" + state.idFasilitas).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getListApproval = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/asset/career-transisition").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_LIST_APPROVAL", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

export default {
  getfasilitas,
  getfasilitasByid,
  insertFasilitas,
  insertMasterFasilitas,
  getMasterFasilitasByid,
  deleteMasterFacility,
  getListApproval,
  getAllFasilitas,
  deleteUserFasilitas
};
